import type { BookingDetailsParticipantType } from './types'

const MAIN_BOOKER_TYPE = 'MainBooker'
const BABY_TYPE = 'Baby'
const CHILD_TYPE = 'Child'
const ADULT_TYPE = 'Adult'

interface ParticipantTypeSource {
  type: string
  title: string
}

function normalize(value: string): string {
  return value.trim().toLowerCase()
}

export function getParticipantType(participant: ParticipantTypeSource): BookingDetailsParticipantType {
  if (normalize(participant.type || '') === 'mainbooker') {
    return MAIN_BOOKER_TYPE
  }

  const normalizedTitle = normalize(participant.title || '')

  if (normalizedTitle === 'baby') {
    return BABY_TYPE
  }

  if (normalizedTitle === 'kid') {
    return CHILD_TYPE
  }

  return ADULT_TYPE
}
